import { getStringErrors, getValidationErrorDictionary, getValidationErrors, isValidEmail } from "../../../../logic/ValidationChecks/Validation";
import { ValidationCheck } from "../../../../stores/models/ValidationCheck";
import { ValidationError } from "../../../../stores/models/ValidationError";
import { LoginStepValues } from "../_interfaces/IOrganizationSignUpStepTypeValues";

const validationChecks: (stepValues: LoginStepValues) => ValidationCheck<LoginStepValues>[] =
    (stepValues) => [{
        name: 'email length',
        condition: (stepValues: LoginStepValues) => {
            return stepValues.username.length > 0;
        },
        error: new ValidationError('Please enter your email.', ['username'])
    }, {
        name: 'valid email',
        condition: (stepValues: LoginStepValues) => {
            return stepValues.username.length === 0 || isValidEmail(stepValues.username);
        },
        error: new ValidationError('Please enter a valid email address.', ['username'])
    }, {
        name: 'password length',
        condition: (stepValues: LoginStepValues) => {
            return stepValues.password.length > 0;
        },
        error: new ValidationError('Please enter your password.', ['password'])
    }];

export const OrganizationSignUpLoginValidation = (stepValues: LoginStepValues) => {
    return {
        errors: getStringErrors(getValidationErrorDictionary(validationChecks, stepValues)),
        valid: getValidationErrors(validationChecks, stepValues).length === 0
    }
}